import React, { useCallback, useState } from "react";
import { observer } from "mobx-react";
import { ItemsContainer } from "./Items.styled";
import EmailItem from "../../../../components/itemList/EmailItemList";
import EmailSlideOut from "../../../../components/PreviewSlideOut/EmailSlideOut";

const Items = observer(({ items = [] }) => {
  const [showEmailSlideOut, setShowEmailSlideOut] = useState(false);
  const [selectedEmail, setSelectedEmail] = useState(null);

  const handleOpenSlideOut = useCallback((email) => {
    setSelectedEmail(email);
    setShowEmailSlideOut(true);
  }, []);

  const handleCloseSlideOut = useCallback(() => {
    setShowEmailSlideOut(false);
    setSelectedEmail(null);
  }, []);

  return (
    <>
      <ItemsContainer>
        {items.map((email) => (
          <EmailItem
            key={email.id}
            info={email}
            onOpen={handleOpenSlideOut}
          />
        ))}
      </ItemsContainer>
      <EmailSlideOut
        open={showEmailSlideOut}
        onClose={handleCloseSlideOut}
        email={selectedEmail}
      />
    </>
  );
});

export default Items;
